import { styled } from 'styled-components'
import { BoxProps, boxable } from './themeMappings/props'

const Box = styled.div<BoxProps>`
  box-sizing: border-box;
  ${boxable}
`

export default Box
